
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alumniblogg/[alumniberattelse]",
      function () {
        return require("private-next-pages/alumniblogg/[alumniberattelse].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alumniblogg/[alumniberattelse]"])
      });
    }
  